<template>
	<div>
		<Broadcasts />

		<div class="main-menu-area">
			<div class="row w-100 m-0">

				<div class="col-4">
					<div class="logo"><a :href="$appConfig['link_logo_'+currentLanguage]" target="_blank"><img src="/images/logo.png" :alt="$t('site_name')" :title="$t('site_name')" /></a></div>
				</div>

				<div class="col pt-2">
					<div class="float-right">
						<a :href="$appConfig['link_urgent_'+currentLanguage]" target="_blank" class="btn btn-primary">{{ $t('urgent_care')}} <font-awesome-icon icon="chevron-right" /></a>
					</div>
					<div v-if="locales.length > 1" class="btn-group float-right mr-2">
						<button :class="(currentLanguage == 'en') ? 'btn btn-primary' : 'btn btn-light border'" @click="switchLocal('en')">En</button>
						<button :class="(currentLanguage == 'fr') ? 'btn btn-primary' : 'btn btn-light border'" @click="switchLocal('fr')">Fr</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import i18n from '@/i18n';
import moment from 'moment';

export default {
	name: 'Header',
	components: {
		Broadcasts: () => import('@/components/Broadcasts')
	},
	computed: {
		...mapGetters(["isLoggedIn"]),
		locales () {
			return this.$root.$i18n.availableLocales;
		},
		currentLanguage () {
			return i18n.locale;
		}
	},
	methods: {
		...mapActions(['changeLocale']),
		switchLocal (lang) {
			if ( i18n.availableLocales.indexOf(lang) >= 0) {
				i18n.locale = lang;
				moment.locale(lang);
				// Set User Profile locale Setting
				if (this.isLoggedIn) this.changeLocale(lang);
			}
		}
	}
}
</script>
